var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2",attrs:{"id":"charts"}},[(_vm.series)?_c('apexchart',{attrs:{"type":"bar","height":"250","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }